// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1mhFD","legacyBtn":"MutateMid_legacyBtn__1R1uv"};